module.exports = __webpack_public_path__ + "static/media/onoiwa-nav-l3.0a63e576.png";